module.exports = __webpack_public_path__ + "media/blank_avatar/blank_avatar-1c12617b.jpg";